/*
 * @Author: kian
 * @Date: 2021-11-29 15:47:23
 * @LastEditors: kian
 * @LastEditTime: 2021-12-07 14:46:25
 * @Description:
 */
/**
 * @description 获取组合收益
 * @returns { Object } {portfolioCode,profitTimeRange}时间范围 THREE_MONTHS、YEAR、ALL.
 */
export const GetPortfolioIncome = params => {
  return {
    url: '/api/portfolio/profit/v1',
    method: 'get',
    params,
  };
};
/**
 * 获取用户创建的组合列表
 *
 * @param {number} userId - 用户🆔
 */
export const GetUserPortfolioList = userId => {
  return {
    url: '/api/portfolio/list/v1',
    method: 'get',
    params: {
      userId,
    },
  };
};

/**
 * 获取用户关注的组合列表
 * @param {number} userId
 */
export const GetUserFollowPortfolioList = userId => {
  return {
    url: `/api/portfolio/${userId}/follow/list/v1`,
    method: 'get',
  };
};

/**
 * @description 获取组合月度收益
 * @returns { Object } {portfolioCode}
 */
export const GetPortfolioMonthProfit = code => {
  return {
    url: `/api/portfolio/monthProfit/v1?portfolioCode=${code}`,
    method: 'get',
  };
};
/**
 * 关注组合
 *
 * @param {string[]} portfolioCodeList 组合代码列表
 */
export const AddFollowPortfolio = portfolioCodeList => {
  return {
    url: `/api/portfolio/follow/v1`,
    method: 'post',
    data: {
      portfolioCodeList,
    },
  };
};

/**
 * 取关组合
 *
 * @param {string[]} portfolioCodeList 组合代码列表
 */
export const DeleteFollowPortfolio = portfolioCodeList => {
  return {
    url: `/api/portfolio/follow/v1`,
    method: 'delete',
    data: {
      portfolioCodeList,
    },
  };
};

/**
 * @description 创建组合文本校验
 * @param { object } data 请求参数
 */
export const CheckCreateContent = data => {
  return {
    url: '/api/portfolio/detect/chars/v1',
    method: 'post',
    data,
  };
};

/**
 * @description 创建组合
 * @param { object } data 请求参数
 */
export const CreatePortfolio = data => {
  return {
    url: '/api/portfolio/add/v1',
    method: 'post',
    data,
  };
};

/**
 * @description 编辑组合
 * @param { string } portfolioCode 组合代码
 * @param { object } data 请求参数
 */
export const EditPortfolio = (portfolioCode, data) => {
  return {
    url: `/api/portfolio/${portfolioCode}/v1`,
    method: 'put',
    data,
  };
};

/**
 * @description 获取组合详情
 * @param { string } portfolioCode 组合代码
 */
export const DetailPortfolio = portfolioCode => {
  return {
    url: `/api/portfolio/${portfolioCode}/detail/v1`,
    method: 'get',
  };
};

/**
 * @description 获取组合股票配置
 * @returns { Object } {portfolioCode}
 */
export const GetPortfolioStockAllocation = code => {
  return {
    url: `/api/portfolio/stockConfig/v1?portfolioCode=${code}`,
    method: 'get',
  };
};

/**
 * @description 关停组合
 * @param { string } portfolioCode 组合代码
 */
export const ClosePortfolio = portfolioCode => {
  return {
    url: `/api/portfolio/${portfolioCode}/close/v1`,
    method: 'post',
  };
};

/**
 * 获取组合关注状态
 * @param {string[]} portfolioCodeList 组合代码列表
 */
export const GetPortfolioFollowStatus = portfolioCodeList => {
  return {
    url: `/portfolio/follow/status/v1`,
    method: 'post',
    data: {
      portfolioCodeList,
    },
  };
};

/**
 * @description 调仓页面初始化
 * @param { string } portfolioCode 组合代码
 */
export const GetPreAdjust = portfolioCode => {
  return {
    url: '/api/portfolio/pre/adjust/v1',
    method: 'get',
    params: {
      portfolioCode,
    },
  };
};

/**
 * @description 获取组合详情页动态列表
 */
export const GetPortfolioCommentList = ({
  portfolioCode,
  userId,
  timestamp,
}) => {
  return {
    url: `/api/community/portfolio/${portfolioCode}/dynamics/v1`,
    method: 'get',
    params: {
      userId,
      timestamp,
    },
  };
};

/**
 * @description 获取组合股票
 * @param { string } param 请求参数
 */
export const GetPortfolioStock = params => {
  return {
    url: '/api/search/portfolio/stock/keyword/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 调仓页添加股票
 * @param { object } data 请求参数
 */
export const BuildAddStock = data => {
  return {
    url: '/api/portfolio/add/stock',
    method: 'post',
    data,
  };
};

/**
 * @description 提交调仓结果
 * @param { object } data 请求参数
 */
export const BuildSubmit = data => {
  return {
    url: '/api/portfolio/adjust/v1',
    method: 'post',
    data,
  };
};

/**
 * @description 搜索组合
 */
export const SearchPortfolios = ({ keyword, page, count }) => {
  return {
    url: `/api/search/portfolio/keyword/v1`,
    method: 'get',
    params: {
      keyword,
      page,
      count,
    },
  };
};

/**
 * @description 获取历史净值
 */
export const getNetValues = params => {
  return {
    url: '/api/portfolio/netValues/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 获取组合信息
 */
export const GetPortfolioData = portfolioCode => {
  return {
    url: `/api/portfolio/head/v1`,
    method: 'get',
    params: {
      portfolioCode,
    },
  };
};

/**
 *  最大回撤接口
 * @param {*} portfolioCode
 * @returns
 */
export const GetMaximumRetraction = portfolioCode => {
  return {
    url: `/api/portfolio/drawdown/v1?portfolioCode=${portfolioCode}`,
    method: 'get',
  };
};

/**
 * @description 获取最新调仓
 * @param { Object } params 请求参数
 */
export const GetListAdjustHistory = params => {
  return {
    url: '/api/portfolio/listAdjustHistory/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 批量查询调仓
 * @param { Object } params 请求参数
 */
export const GetBatchQueryAdjust = params => {
  return {
    url: '/api/portfolio/batchQueryAdjust/v1',
    method: 'post',
    data: params,
  };
};

/**
 * @description 获取详细仓位
 * @param { Object } params 请求参数
 */
export const GetPositionDetail = params => {
  return {
    url: '/api/portfolio/positionDetail/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 关注组合成功后分享到社区动态
 * @param { Object } params 请求参数
 */
export const FollowPortfolioToShare = params => {
  return {
    url: '/api/community/portfolio/share/v1',
    method: 'post',
    data: params,
  };
};

/**
 * @description 获取组合粉丝列表
 * @param { Object } params 请求参数
 */
export const GetPortfolioFollow = params => {
  return {
    url: '/api/friendships/portfolio/followers/v1',
    method: 'get',
    params,
  };
};
